import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useAuth } from '../AuthContext';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Loader } from 'rsuite';

function CreateRule({ show, handleClose, onRuleCreated }) {
  const { auth } = useAuth();
  const [loading, setLoading] = useState(false);

  // State for form fields
  const [source, setSource] = useState('');
  const [diameter, setDiameter] = useState(0);
  const [priceAddon, setPriceAddon] = useState(0); // Default value as a number
  const [delticomAddon, setDelticomAddon] = useState(0); // Default value as a number

  const handleSubmit = async () => {
    if (!source || diameter <= 0 || priceAddon <= 0 || delticomAddon <= 0) {
          toast.error('Fält måste fyllas i och vara giltiga nummer större än 0.', {
            position: 'bottom-right',
          });
          return;
        }

    setLoading(true);

    // Simulate sending data to backend
    const formData = {
      source,
      diameter,
      priceAddon,
      delticomAddon,
    };

    console.log('Form Data:', formData);

    try {
          const response = await fetch(`${process.env.REACT_APP_BASE_URL}/pricerules/save-price-rule`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth.token}`
            },
            body: JSON.stringify(formData),
          });
    
          const result = await response.json();
    
          if (response.ok) {
            toast.success(result.message, {
              position: 'bottom-right'
            });
            handleClose();
            onRuleCreated();
          } else {
            toast.error(result.message, {
              position: 'bottom-right'
            });
          }
        } catch (error) {
          console.log(error);
          toast.error('Misslyckades att redigera prisregel: ', error, {
            position: 'bottom-right'
          });
        } finally {
          setLoading(false);
        }

  };

  return (
    <Modal show={show} onHide={handleClose} animation={true}>
      <Modal.Header closeButton>
        <Modal.Title>Skapa prisregel</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <label htmlFor="source" className="form-label">Grossist</label>
          <select
            className="form-select"
            value={source}
            onChange={(e) => setSource(e.target.value)}
          >
            <option value="">Välj en grossist</option>
            <option value="GummiGrossen">GummiGrossen</option>
            <option value="AmRing">AmRing</option>
            <option value="ImazWheels">Imaz Wheels</option>
            <option value="Rautamo">Rautamo</option>
          </select>
        </div>
        <div>
          <label htmlFor="diameter" className="form-label">Tum</label>
          <select
            className="form-select"
            value={diameter}
            onChange={(e) => setDiameter(Number(e.target.value))}
          >
            <option value="">Välj tum</option>
            {[
              10, 12, 13, 14, 15, 16, 17, 17.5, 18, 19, 19.5, 20, 20.5, 21,
              22, 22.5, 23, 24, 26,
            ].map((value) => (
              <option key={value} value={value}>
                {value.toFixed(1)}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label htmlFor="priceAddon" className="form-label">Påslag</label>
          <input
            type="number"
            className="form-control"
            value={priceAddon}
            onChange={(e) => setPriceAddon(Number(e.target.value))} // Convert to number
            />
        </div>
        <div>
          <label htmlFor="delticomAddon" className="form-label">
            Delticom påslag (Ex moms)
          </label>
          <input
            type="number"
            className="form-control"
            value={delticomAddon}
            onChange={(e) => setDelticomAddon(Number(e.target.value))} // Convert to number
            />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Stäng
        </Button>
        <Button
          variant="primary"
          className="d-flex justify-content-center align-items-center text-white"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? (
            <>
              <Loader className="me-2" /> Skapar...
            </>
          ) : (
            'Skapa'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CreateRule;
